"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * NOTE(alexandrawang1): manually pulled this icon from https://www.figma.com/design/NoAX7z4MTQcmV2R9cgWALf/%F0%9F%9A%9A-Fulfilled-by-Faire---25-Pilot-?node-id=13488-5494&t=4rZNw5OQKympXJjM-0
 */
export const Cards = createSVGIcon(
  <>
    <g clipPath="url(#clip0_13488_5490)">
      <path
        d="M3.96677 10.7862C3.81992 11.3443 4.15278 11.9219 4.71082 12.0688L8.84229 13.175C8.9402 13.2044 8.9402 13.3317 8.84229 13.3611L3.68285 14.7415C3.44789 14.8002 3.21292 14.6632 3.14439 14.4282L1.01991 6.48833C0.961174 6.25337 1.09824 6.0184 1.3332 5.94987L5.41572 4.85337C5.48425 4.83379 5.55278 4.90232 5.5332 4.97085L3.97656 10.7764L3.96677 10.7862ZM7.29544 3.1205L14.7066 5.10791C14.922 5.16665 15.0493 5.39183 14.9905 5.60721L13.0129 12.989C12.9542 13.2044 12.729 13.3317 12.5136 13.2729L5.10243 11.2855C4.88705 11.2268 4.75978 11.0016 4.81852 10.7862L6.79614 3.41421C6.85488 3.19882 7.08005 3.07155 7.29544 3.13029V3.1205ZM10.4381 6.224C10.2129 6.16526 9.97796 6.29253 9.91922 6.5177L9.58635 7.74148L8.36257 7.40861C8.1374 7.34987 7.90243 7.47714 7.84369 7.70232C7.78495 7.92749 7.91222 8.16246 8.1374 8.2212L9.36117 8.55407L9.02831 9.77784V9.86596C8.99894 10.0618 9.12621 10.2478 9.32201 10.2967C9.51782 10.3457 9.72341 10.2576 9.81152 10.0813L9.84089 10.003L10.1738 8.77924L11.3975 9.11211H11.4857C11.6815 9.14148 11.8675 9.01421 11.9164 8.8184C11.9654 8.6226 11.8773 8.417 11.701 8.32889L11.6227 8.29952L10.3989 7.96665L10.7318 6.74288C10.7905 6.5177 10.6633 6.28274 10.4381 6.224Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_13488_5490">
        <rect
          width="14"
          height="11.6503"
          fill="white"
          transform="translate(1 3.1106)"
        />
      </clipPath>
    </defs>
  </>,
  "FaireSourceCards",
  {
    viewBox: "0 0 16 17",
    fill: "none",
    color: Core.icon.primary,
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
